import {
  RESET_PASSWORD,
  NEW_ORGANIZER_PASSWORD,
  NEW_ADMIN_PASSWORD,
  NEW_PARTICIPANT_PASSWORD,
} from './config';

export async function resetPassword(value) {
  const url = RESET_PASSWORD;

  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(value),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else if (res.status === 500) {
        return res;
      }
    })
    .then((data) => {
      return data;
    });

  return result;
}

export async function newOrganizerPassword(values) {
  const url = NEW_ORGANIZER_PASSWORD;

  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(values),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        return res;
      }
    })
    .then((data) => {
      if (data.statusCode) {
        return data.statusCode;
      } else {
        return data.status;
      }
    });

  return result;
}

export async function newAdminPassword(values) {
  const url = NEW_ADMIN_PASSWORD;

  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(values),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        return res;
      }
    })
    .then((data) => {
      if (data.statusCode) {
        return data.statusCode;
      } else {
        return data.status;
      }
    });

  return result;
}

export async function newParticipantPassword(values) {
  const url = NEW_PARTICIPANT_PASSWORD;

  const result = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(values),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        return res;
      }
    })
    .then((data) => {
      if (data.statusCode) {
        return data.statusCode;
      } else {
        return data.status;
      }
    });

  return result;
}
